export { useAgeVerificationGate } from './use-age-verification-gate';
